const initialState = {
  list: [],
};
export default function chat(state = initialState, action) {
  let { type, data } = action;
  switch (type) {
    case 'message/list':
      return { ...state, list: data };
    case 'message/send':
      return { ...state, list: [...state.list, ...data] };
    case 'message/sendKeys':
      return { ...state, list: [...state.list, ...data] };
    default:
      return state;
  }
}
